interface AkamaiLoaderProps {
  aspectRatioHeight?: number;
  aspectRatioWidth?: number;
  focalPoint?: { x: number; y: number };
  requestWidth?: number;
  src: string;
  width?: number;
}

export const akamaiLoader = ({
  aspectRatioHeight,
  aspectRatioWidth,
  focalPoint,
  requestWidth,
  src,
  width,
}: AkamaiLoaderProps) => {
  // If the src is not an external URL, return it as-is
  if (src && !src.startsWith('https')) return src;

  const url = new URL(
    `${process.env.NEXT_PUBLIC_IMAGE_PROXY}api/image-proxy/${src?.replace(
      'https://',
      '',
    )}`,
  );

  // We multiply the requested width by 3 to account for the fact that the image will be displayed on a Super Retina XDR (apple).
  const maxNeededWidth = requestWidth ? requestWidth * 3 : undefined;
  // If the requested width exceeds what we need for the display size, we cap it to a reasonable maximum
  const finalWidth =
    maxNeededWidth && width && width > maxNeededWidth ? maxNeededWidth : width;

  if (finalWidth) {
    if (
      aspectRatioHeight &&
      aspectRatioWidth &&
      focalPoint?.x &&
      focalPoint?.y
    ) {
      url.searchParams.append(
        'im',
        `RegionOfInterestCrop,width=${finalWidth},height=${Math.round(
          finalWidth * (aspectRatioHeight / aspectRatioWidth),
        )},regionOfInterest=(${focalPoint.x},${focalPoint.y})`,
      );
    } else {
      url.searchParams.append('imwidth', finalWidth.toString());
    }

    url.searchParams.append('format', 'auto');
  }

  return url.href;
};
